import { collapseImageTiles } from './collapse-image-tiles';
import { collapsedLinkClass } from './constants';
import { expandImageTiles } from './expand-image-tiles';
import { makeOnlyVisibleTilesClickable } from './make-only-visible-tiles-clickable';

export const toggleImageTileExpansion = (showMoreColorsLink: HTMLElement, colorImageTileContainer: HTMLElement, productId: string) => {
    const isCollapsed = showMoreColorsLink.classList.contains(collapsedLinkClass);
    if (isCollapsed) {
        expandImageTiles(showMoreColorsLink, colorImageTileContainer, productId);
    } else {
        collapseImageTiles(showMoreColorsLink, colorImageTileContainer, productId);
    }
    makeOnlyVisibleTilesClickable(colorImageTileContainer);
};
